var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7179_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 100C0 44.7715 44.7715 0 100 0C155.229 0 200 44.7715 200 100C200 155.229 155.229 200 100 200C44.7715 200 0 155.229 0 100Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.209 109.578V109.561C111.516 109.61 107.936 109.82 99.968 109.82C93.597 109.82 89.129 109.642 87.5485 109.561V109.578C63.0485 108.497 44.7742 104.239 44.7742 99.1265C44.7742 94.0295 63.0645 89.7555 87.5485 88.6745V105.336C89.145 105.449 93.742 105.723 100.081 105.723C107.694 105.723 111.5 105.4 112.209 105.336V88.691C136.661 89.7875 154.887 94.0455 154.887 99.1425C154.887 104.239 136.645 108.497 112.209 109.594V109.578ZM112.209 86.965V72.0615H146.323V49.3359H53.4515V72.0615H87.5645V86.965C59.8385 88.239 39 93.723 39 100.303C39 106.884 59.855 112.368 87.5645 113.658V161.432H112.226V113.658C139.903 112.384 160.71 106.9 160.71 100.32C160.71 93.7555 139.903 88.2555 112.226 86.981",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7179_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.3aa97ea47d0639812fb91cea9b965237.svg";
export { ForwardRef as ReactComponent };